export default {
  promotion: 'Акция',
  alifshopBanner: {
    title: 'Покупайте онлайн на Alif Shop',
    button: 'Перейти на Alif Shop',
  },
  banner: {
    title: 'Покупайте в рассрочку в {name}',
    description: 'Вы можете купить товары в рассрочку до 24 месяцев у различных партнёров по всему Узбекистану',
    button: 'Как купить?',
  },
  howToBuy: {
    title: 'Как проходит покупка',
    items: [
      {
        title: 'Выберите товар',
        description: 'От электроники до автотоваров',
      },
      {
        title: 'Оформите',
        description: 'Покажите паспорт и карту продавцу',
      },
      {
        title: 'Получите товар',
        description: 'Рассмотрим в течение двух минут',
      },
    ],
    qr: {
      title: 'Если есть QR',
      description: 'Отсканируйте его через приложение Alif и оформите сами за 1 минуту',
    },
  },
  filter: 'Фильтр',
  monthsShort: 'мес',
  daysShort: 'дн.',
};
